import * as React from 'react';
import { NotFound } from '../DocParts/NotFound';
import { withTranslation } from '@wix/fe-essentials/i18n';
const PriceQuoteNotFound = ({ businessEmail, businessName, t, }) => (React.createElement(NotFound, { messageText: t('invoice-view:price-quote.not-found.message', {
        businessName,
        businessEmail,
    }), headerText: t('invoice-view:price-quote.not-found.header') }));
export default withTranslation(['invoice-view', 'locale-data'])(PriceQuoteNotFound);
//# sourceMappingURL=PriceQuoteNotFound.js.map